/**
 * Centralized JSON-LD structured data for Google Rich Results.
 * All schemas reference seo-config.ts for URLs and site metadata.
 */
import { SITE_URL } from "./seo-config";

const PHONE = "+201031849849";
const IMAGE = `${SITE_URL}/og-image.webp`;
const HERO_IMAGE = `${SITE_URL}/images/hero-profile.webp`;

/* ─── FAQPage ─── */
export const faqItems = [
  {
    question: "ما هي التغذية العلاجية وكيف تختلف عن الحمية الغذائية العادية؟",
    answer:
      "التغذية العلاجية تستخدم الغذاء كأداة طبية لعلاج أمراض مثل السكري والضغط — وليست مجرد حمية غذائية لخسارة الوزن. دكتورة تغذية علاجية متخصصة تصمم لك نظام غذائي صحي مبني على تحاليلك وحالتك الصحية لنتائج دائمة.",
  },
  {
    question: "هل توفرون جدول نظام غذائي صحي يومي متكامل؟",
    answer:
      "نعم، كل برنامج يتضمن جدول نظام غذائي صحي يومي متكامل مخصص لحالتك — يشمل وجبات رئيسية وسناكس وتوزيع العناصر الغذائية. مناسب لمرضى السكري والضغط ومن يعاني زيادة الوزن أو مشاكل الأمعاء.",
  },
  {
    question: "المتابعة بتكون إزاي؟",
    answer:
      "مكالمات كوتشينج أسبوعية (٣٠-٩٠ دقيقة حسب الباقة) + دعم واتساب يومي + متابعة تقدمك المستمر مع تعديل الخطة حسب نتائجك. البرنامج أونلاين بالكامل ويناسب المسافرين.",
  },
  {
    question: "النتايج بتبان بعد قد إيه؟",
    answer:
      "الأسبوع الأول: تحسن في الطاقة والنوم. الأسبوع ٣-٤: نتائج جسدية واضحة. ٨-١٢ أسبوع: تحول كامل في نمط الحياة. النتائج تختلف حسب الالتزام والحالة الصحية.",
  },
  {
    question: "إيه أسعار الباقات بالعملات الخليجية؟",
    answer:
      "باقة البداية ٣,٥٠٠ ج.م (≈٢٦٠ ريال سعودي). باقة التحول ٩,٠٠٠ ج.م (≈٦٧٠ ريال). باقة النخبة ٢٥,٠٠٠ ج.م (≈١,٨٦٠ ريال). الدفع بالجنيه المصري والأسعار تقريبية حسب سعر الصرف.",
  },
];

export function buildFAQPageSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqItems.map((item) => ({
      "@type": "Question",
      name: item.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: item.answer,
      },
    })),
  };
}

/* ─── MedicalBusiness (replaces LocalBusiness + ProfessionalService) ─── */
export function buildMedicalBusinessSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "MedicalBusiness",
    "@id": `${SITE_URL}/#business`,
    name: "د. شيماء أنور — حيوية كوتشينج",
    alternateName: "Dr Shimaa Anwer — Vitality Coaching",
    description:
      "دكتورة تغذية علاجية أونلاين — نظام غذائي صحي وجدول نظام غذائي صحي يومي متكامل. أول برنامج عربي يغيّر العقلية قبل الحمية الغذائية.",
    url: SITE_URL,
    telephone: PHONE,
    email: "lifechange@drshimaaanwer.com",
    image: IMAGE,
    logo: { "@type": "ImageObject", url: IMAGE, width: 1200, height: 630 },
    priceRange: "٣,٥٠٠ - ٢٥,٠٠٠ ج.م",
    address: {
      "@type": "PostalAddress",
      addressLocality: "القاهرة",
      addressRegion: "القاهرة",
      addressCountry: "EG",
    },
    geo: { "@type": "GeoCoordinates", latitude: 30.0444, longitude: 31.2357 },
    openingHoursSpecification: {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday"],
      opens: "09:00",
      closes: "17:00",
    },
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: "4.9",
      reviewCount: "500",
      bestRating: "5",
      worstRating: "1",
    },
    review: [
      { "@type": "Review", author: { "@type": "Person", name: "سارة أحمد" }, reviewRating: { "@type": "Rating", ratingValue: 5, bestRating: 5, worstRating: 1 }, reviewBody: "الشغل مع الكوتش ده غيّر علاقتي بالأكل تماماً. نزلت ١٥ كيلو وطاقتي بقت عالية جداً.", datePublished: "2024-09-15" },
      { "@type": "Review", author: { "@type": "Person", name: "محمد خالد" }, reviewRating: { "@type": "Rating", ratingValue: 5, bestRating: 5, worstRating: 1 }, reviewBody: "كواحد بيزنس مشغول، كنت محتاج حاجة مستدامة. برنامج النخبة مناسبني جداً. إنتاجيتي وتركيزي بقوا أحسن.", datePublished: "2024-10-02" },
      { "@type": "Review", author: { "@type": "Person", name: "نورهان محمود" }, reviewRating: { "@type": "Rating", ratingValue: 5, bestRating: 5, worstRating: 1 }, reviewBody: "أخيراً لقيت نظام يشتغل مع العيلة كلها. الوصفات لذيذة والدعم مذهل.", datePublished: "2024-11-20" },
      { "@type": "Review", author: { "@type": "Person", name: "أحمد عادل" }, reviewRating: { "@type": "Rating", ratingValue: 5, bestRating: 5, worstRating: 1 }, reviewBody: "بعد سنين من الدايتات، أخيراً فهمت جسمي. النظام العلمي ساعدني أرجع أدائي الرياضي وثقتي.", datePublished: "2025-01-10" },
    ],
    areaServed: [
      { "@type": "Country", name: "Egypt" },
      { "@type": "Country", name: "Saudi Arabia" },
      { "@type": "Country", name: "United Arab Emirates" },
      { "@type": "Country", name: "Kuwait" },
      { "@type": "Country", name: "Qatar" },
      { "@type": "Country", name: "Bahrain" },
      { "@type": "Country", name: "Oman" },
    ],
    sameAs: [
      "https://www.facebook.com/drshimaaanwer",
      "https://www.instagram.com/drshimaaanwer",
    ],
    medicalSpecialty: ["ClinicalNutrition", "LifestyleMedicine"],
    serviceType: [
      "دكتورة تغذية علاجية",
      "نظام غذائي صحي",
      "جدول نظام غذائي صحي يومي متكامل",
      "حمية غذائية",
      "كوتشينج نفسي",
    ],
  };
}

/* ─── Person / Physician ─── */
export function buildPhysicianSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "Physician",
    "@id": `${SITE_URL}/#physician`,
    name: "د. شيماء أنور",
    alternateName: "Dr. Shimaa Anwer",
    jobTitle: "أستاذ الصحة العامة — استشاري التغذية العلاجية وطب نمط الحياة",
    description:
      "أستاذ الصحة العامة بكلية الطب واستشاري التغذية العلاجية. صاحبة أول برنامج عربي يجمع بين تغيير العقلية والتغذية العلاجية القائمة على الأدلة.",
    url: `${SITE_URL}/about`,
    image: { "@type": "ImageObject", url: HERO_IMAGE, width: 600, height: 750 },
    medicalSpecialty: [
      { "@type": "MedicalSpecialty", name: "Clinical Nutrition" },
      { "@type": "MedicalSpecialty", name: "Lifestyle Medicine" },
      { "@type": "MedicalSpecialty", name: "Public Health" },
    ],
    alumniOf: { "@type": "EducationalOrganization", name: "كلية الطب" },
    memberOf: {
      "@type": "MedicalOrganization",
      name: "الكلية الأمريكية لطب نمط الحياة (ACLM)",
      url: "https://www.lifestylemedicine.org",
    },
    worksFor: {
      "@type": "MedicalBusiness",
      "@id": `${SITE_URL}/#business`,
      name: "د. شيماء أنور — حيوية كوتشينج",
      url: SITE_URL,
      telephone: PHONE,
      address: {
        "@type": "PostalAddress",
        addressLocality: "القاهرة",
        addressCountry: "EG",
      },
    },
    knowsAbout: [
      "التغذية العلاجية",
      "إدارة السكري من النوع الثاني",
      "صحة الأمعاء والميكروبيوم",
      "السمنة ومقاومة الأنسولين",
      "طب نمط الحياة",
      "المكملات الغذائية",
    ],
    sameAs: [
      "https://www.facebook.com/drshimaaanwer",
      "https://www.instagram.com/drshimaaanwer",
    ],
  };
}

/* ─── Service offers ─── */
export function buildServiceSchemas() {
  const services = [
    {
      name: "باقة البداية",
      description: "بداية قوية لكسر العادات السيئة وبناء أساس صحي — ٤ أسابيع مع دكتورة تغذية علاجية",
      price: "3500",
      duration: "P28D",
    },
    {
      name: "باقة التحول",
      description: "برنامج شامل لتغيير نمط حياتك مع جدول نظام غذائي صحي يومي متكامل — ١٢ أسبوع",
      price: "9000",
      duration: "P84D",
    },
    {
      name: "باقة النخبة",
      description: "دعم VIP للمديرين التنفيذيين — حمية غذائية مخصصة مع متابعة ٦ شهور",
      price: "25000",
      duration: "P180D",
    },
  ];

  return services.map((s) => ({
    "@context": "https://schema.org",
    "@type": "Service",
    name: s.name,
    description: s.description,
    provider: {
      "@type": "Physician",
      "@id": `${SITE_URL}/#physician`,
      name: "د. شيماء أنور",
      url: `${SITE_URL}/about`,
    },
    areaServed: { "@type": "Country", name: "Egypt" },
    offers: {
      "@type": "Offer",
      price: s.price,
      priceCurrency: "EGP",
      availability: "https://schema.org/InStock",
      validFrom: "2025-01-01",
      priceValidUntil: "2025-12-31",
      url: `${SITE_URL}/services`,
    },
    termsOfService: `${SITE_URL}/privacy-policy`,
  }));
}


/* ─── WebSite schema with SearchAction for sitelinks ─── */
export function buildWebSiteSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "@id": `${SITE_URL}/#website`,
    name: "دكتورة شيماء انور — استشاري التغذية العلاجية وطب نمط الحياة",
    alternateName: ["Dr Shimaa Anwer", "د. شيماء أنور", "دكتورة شيماء أنور"],
    url: SITE_URL,
    inLanguage: "ar",
    description: "اول برنامج متخصص في التغذية العلاجية يعمل على تغيير العقلية قبل اتباع النظام الأمثل لك.",
    publisher: { "@type": "Person", "@id": `${SITE_URL}/#physician` },
    potentialAction: [
      {
        "@type": "SearchAction",
        target: {
          "@type": "EntryPoint",
          urlTemplate: `${SITE_URL}/blog?q={search_term_string}`,
        },
        "query-input": "required name=search_term_string",
      },
      {
        "@type": "ReadAction",
        target: `${SITE_URL}/blog`,
      },
    ],
  };
}

/* ─── Organization with logo for Google Knowledge Panel ─── */
export function buildOrganizationSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    "@id": `${SITE_URL}/#organization`,
    name: "حيوية كوتشينج — Vitality Coaching",
    alternateName: "Dr Shimaa Anwer Vitality Coaching",
    url: SITE_URL,
    logo: {
      "@type": "ImageObject",
      url: IMAGE,
      width: 1200,
      height: 630,
      caption: "حيوية كوتشينج — د. شيماء أنور",
    },
    image: IMAGE,
    description: "برنامج التغذية العلاجية وطب نمط الحياة الأول من نوعه — تغيير العقلية قبل الدايت.",
    founder: { "@type": "Person", "@id": `${SITE_URL}/#physician` },
    contactPoint: {
      "@type": "ContactPoint",
      telephone: PHONE,
      contactType: "customer service",
      availableLanguage: ["Arabic", "English"],
      areaServed: ["EG", "SA", "AE", "KW", "QA", "BH", "OM"],
    },
    sameAs: [
      "https://www.facebook.com/drshimaaanwer",
      "https://www.instagram.com/drshimaaanwer",
    ],
  };
}

/* ─── SiteNavigationElement for sitelinks ─── */
export function buildSiteNavigationSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name: "التنقل الرئيسي",
    itemListElement: [
      { "@type": "SiteNavigationElement", position: 1, name: "الرئيسية", url: SITE_URL },
      { "@type": "SiteNavigationElement", position: 2, name: "الخدمات والباقات", url: `${SITE_URL}/services` },
      { "@type": "SiteNavigationElement", position: 3, name: "عن الدكتورة", url: `${SITE_URL}/about` },
      { "@type": "SiteNavigationElement", position: 4, name: "المدونة", url: `${SITE_URL}/blog` },
    ],
  };
}

/* ─── HowTo: booking process (eligible for Rich Result) ─── */
export function buildHowToSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "HowTo",
    name: "إزاي تحجز جلسة تغذية علاجية مع د. شيماء أنور",
    description: "٣ خطوات بسيطة لبدء رحلتك الصحية — احجز جلسة حجر الأساس المجانية أونلاين.",
    totalTime: "PT5M",
    estimatedCost: { "@type": "MonetaryAmount", currency: "EGP", value: "0" },
    step: [
      {
        "@type": "HowToStep",
        position: 1,
        name: "احجز جلسة حجر الأساس",
        text: "اضغط على زر 'احجز جلستك المجانية' واختار الموعد المناسب ليك.",
        url: SITE_URL,
      },
      {
        "@type": "HowToStep",
        position: 2,
        name: "جلسة التقييم الشامل (٤٠ دقيقة)",
        text: "هنقيّم حالتك الصحية والعادات الغذائية والأهداف — ونحدد إذا كنا مناسبين لبعض.",
      },
      {
        "@type": "HowToStep",
        position: 3,
        name: "ابدأ برنامجك المخصص",
        text: "هتاخد نظام غذائي مخصص ١٠٠% مع جدول يومي متكامل ومتابعة أسبوعية.",
      },
    ],
  };
}

/* ─── KSA-specific FAQ schema ─── */
export const ksaFaqItems = [
  {
    question: "كيف أحصل على دكتورة تغذية علاجية أونلاين في السعودية؟",
    answer:
      "د. شيماء أنور تقدم استشارات تغذية علاجية أونلاين لكل مدن السعودية — الرياض، جدة، الدمام، الخبر، المدينة، مكة، تبوك. الجلسات عبر زووم بالكامل، ويتم تصميم خطة تغذية شخصية مبنية على تحاليلك وحالتك الصحية وتفضيلاتك من الأكل السعودي المحلي.",
  },
  {
    question: "وش أسعار باقات التغذية العلاجية بالريال السعودي؟",
    answer:
      "باقة البداية ≈٢٦٠ ريال سعودي (٤ أسابيع). باقة التحول ≈٦٧٠ ريال (١٢ أسبوع — الأكثر طلباً). باقة النخبة ≈١,٨٦٠ ريال (٦ شهور VIP). جلسة حجر الأساس بـ ٤٠ ريال فقط (٤٠ دقيقة). الأسعار تقريبية حسب سعر الصرف الحالي.",
  },
  {
    question: "هل تناسب الخطة الأكل السعودي مثل الكبسة والمندي؟",
    answer:
      "نعم تماماً. د. شيماء تصمم خطط تغذية تتضمن بدائل صحية للأكلات السعودية المحبوبة — كبسة بأرز بسمتي مع دجاج مشوي بدل المقلي، مندي صحي، جريش بكمية متوازنة، وفطور تقليدي مثل الفول والبيض مع تعديلات على الكميات والمكونات لتحقيق أهدافك الصحية بدون حرمان.",
  },
  {
    question: "هل البرنامج يناسب نساء السعودية اللي يعانين من تكيس المبايض (PCOS)؟",
    answer:
      "نعم، تكيس المبايض شائع جداً في السعودية ويأثر على ٢٠-٢٥% من النساء. د. شيماء تصمم بروتوكول تغذية مضاد للالتهابات مخصص لـ PCOS — يقلل مقاومة الأنسولين، يوازن الهرمونات، ويتعامل مع زيادة الوزن وحب الشباب وضعف الإباضة. كل خطة مبنية على تحاليلك الهرمونية.",
  },
  {
    question: "كيف تتم المتابعة وأنا في السعودية؟",
    answer:
      "كل التواصل أونلاين بالكامل — مكالمات كوتشينج أسبوعية عبر زووم (٣٠-٩٠ دقيقة حسب الباقة)، دعم واتساب يومي، خطة وجبات مخصصة على PDF، ومتابعة مستمرة لتقدمك. توقيت الجلسات يتناسب مع ساعات السعودية، والدفع متاح عبر تحويل بنكي أو بطاقة ائتمان.",
  },
  {
    question: "كم وقت أحتاج عشان أشوف نتائج؟",
    answer:
      "الأسبوع الأول: تحسن واضح في الطاقة والنوم. الأسبوع ٣-٤: نزول وزن مرئي وتحسن في المزاج. الأسبوع ٨-١٢: تحول كامل في نمط الحياة وعلاقتك مع الأكل. عملاؤنا في السعودية ينزّلون في المتوسط ١٠-١٨ كيلو خلال ٤ شهور بدون حرمان أو دايت قاسي.",
  },
];

export function buildKsaFaqSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: ksaFaqItems.map((item) => ({
      "@type": "Question",
      name: item.question,
      acceptedAnswer: { "@type": "Answer", text: item.answer },
    })),
  };
}

/* ─── KSA-specific MedicalBusiness schema ─── */
export function buildKsaMedicalBusinessSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "MedicalBusiness",
    "@id": `${SITE_URL}/sa#business`,
    name: "د. شيماء أنور — تغذية علاجية أونلاين للسعودية",
    alternateName: "Dr Shimaa Anwer — Saudi Arabia Online Nutrition",
    description:
      "دكتورة تغذية علاجية أونلاين متخصصة في خدمة عملاء المملكة العربية السعودية — الرياض، جدة، الدمام، الخبر. خطة تغذية شخصية مع بدائل من الأكل السعودي المحلي.",
    url: `${SITE_URL}/sa`,
    telephone: PHONE,
    email: "lifechange@drshimaaanwer.com",
    image: IMAGE,
    logo: { "@type": "ImageObject", url: IMAGE, width: 1200, height: 630 },
    priceRange: "٤٠ - ١,٨٦٠ ر.س",
    address: { "@type": "PostalAddress", addressCountry: "SA" },
    areaServed: [
      { "@type": "Country", name: "Saudi Arabia" },
      { "@type": "City", name: "Riyadh" },
      { "@type": "City", name: "Jeddah" },
      { "@type": "City", name: "Dammam" },
      { "@type": "City", name: "Khobar" },
      { "@type": "City", name: "Mecca" },
      { "@type": "City", name: "Medina" },
    ],
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: "4.9",
      reviewCount: "500",
      bestRating: "5",
      worstRating: "1",
    },
    review: [
      { "@type": "Review", author: { "@type": "Person", name: "نورة العتيبي" }, reviewRating: { "@type": "Rating", ratingValue: 5, bestRating: 5, worstRating: 1 }, reviewBody: "أفضل دكتورة تغذية علاجية تعاملت معها أونلاين من الرياض. خطة شخصية تناسب الأكل السعودي ونتائج خلال شهر.", datePublished: "2025-01-20" },
      { "@type": "Review", author: { "@type": "Person", name: "عبدالله القحطاني" }, reviewRating: { "@type": "Rating", ratingValue: 5, bestRating: 5, worstRating: 1 }, reviewBody: "من جدة — البرنامج غيّر حياتي تماماً. التزمت ٣ شهور ونزلت ١٢ كيلو بدون حرمان.", datePublished: "2025-02-10" },
      { "@type": "Review", author: { "@type": "Person", name: "ريم الشمري" }, reviewRating: { "@type": "Rating", ratingValue: 5, bestRating: 5, worstRating: 1 }, reviewBody: "متابعة ممتازة لتكيس المبايض، الهرمونات اتعدلت والوزن نزل تدريجي وثابت.", datePublished: "2025-03-05" },
    ],
    medicalSpecialty: ["ClinicalNutrition", "LifestyleMedicine"],
    serviceType: [
      "دكتورة تغذية علاجية أونلاين السعودية",
      "خطة تغذية للأكل السعودي",
      "علاج تكيس المبايض PCOS",
      "تغذية مرضى السكري",
    ],
  };
}
